<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired, isSubOption: isSubOption}">
    <span class="idStkr">
      {{isSubOption ? `${isSubOption.parentLabel}:${isSubOption.parentValue} > ` : ''}}{{itemSetting.action.labelValue}}
    </span>
    <div class="label" :style="labelStyle">{{itemSetting.action.label[activeLang]}}</div>
      <select
        :name="`select_${id}_${moduleIndex}`"
        class="input"
        :style="valueStyle">
        <option
          v-for="(option, index) in itemSetting.action.item"
          :key="index"
          :value="option.value">
          {{option.label[activeLang]}}
          <span class="optionPrice">
            {{optionPrice(option.price)}}
          </span>
        </option>
      </select>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
export default {
  name: 'SelectModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting',
    'subOption'
  ],
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    currency () {
      return this.$store.getters['setting/getCurrencyCode'].toUpperCase()
    },
    isSubOption () {
      const id = this.id
      return this.subOption.find(x => x.child === id)
    }
  },
  methods: {
    optionPrice (price) {
      const code = this.currency
      const disabledSymbol = this.$store.getters['setting/getData']?.currency?.disabledCurrencySymbol ?? false
      return price ? regExp.priceFormat(price, code, disabledSymbol) : ''
    }
  }
}
</script>
